import script from "./TargetSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetSetting.vue?vue&type=script&lang=ts&setup=true"

import "./TargetSetting.vue?vue&type=style&index=0&id=2210e02a&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2210e02a"]])

export default __exports__